import { actionErrorMessage, isManagedConflict } from '../../api/client'
import { toast } from '../../state/toasts'
import { syncAll } from '../../sync/syncEngine'

/**
 * Toast a failed channel action ("{prefix} {reason}"). A managed conflict gets its own message, and means this
 * device's copy of the channel is out of date (the UI hides what the integration controls), so sync.
 */
export function toastChannelError(prefix: string, error: unknown): void {
  toast(actionErrorMessage(prefix, error))
  if (isManagedConflict(error)) void syncAll()
}
